import QualifyingQuestionTemplateForm from './qualifyingQuestionTemplateForm.container';

export default QualifyingQuestionTemplateForm;
